import Styles from "./ChallengeType.module.scss"
import PerfectButtonLeft from "../../assets/svg/PerfectButtonIconLeft"
import PerfectButtonRight from "../../assets/svg/PerfectButtonIconRight"
const ChallengeType = ({
  line1 = "Rewarding",
  line2 = "Missions",
  line3 = "Earn 300 coins daily",
  backgroundColor = "#FFEAEE",
  txtColor = "#08A742",
  btnText = "Playss Now",
  btnBg = "#FA5743",
  btnFill = "#fff",
  onClick,
}) => {
  return (
    <>
      <div className={Styles.main_container} style={{ background: backgroundColor }}>
        <h2 className={Styles.text1} style={{ color: txtColor }}>{line1}</h2>
        <h3 className={Styles.text2} style={{ color: txtColor }}>{line2}</h3>
        <p className={Styles.text3} >{line3}</p>

        <div className={Styles.button_type_true} style={{ background: btnBg ,color : btnFill }} onClick={onClick}>
          <PerfectButtonRight width={12} height={18} fillColor={btnFill} />
          <p className={Styles.button_text}>
          {btnText}
          </p>
          <PerfectButtonLeft width={12} height={18} fillColor={btnFill} />
        </div>

      </div>
    </>
  )
}

export default ChallengeType;